export type ErrorPageContent = {
	titlePrefix: string;
	titleHighlight: string;
	titleSuffix: string;
	description: string;
	primaryHref: string;
	primaryLabel: string;
	secondaryLabel: string;
	footerNote: string;
};

type ErrorContentProps = {
	readonly content: ErrorPageContent;
};

export default function ErrorContent({ content }: ErrorContentProps) {
	return (
		<section className="mx-auto max-w-xl lg:mx-0">
			<h1 className="text-6xl leading-none font-bold tracking-tight text-balance lg:text-7xl">
				{content.titlePrefix}
				<span className="text-[#FF2E6E]">{content.titleHighlight}</span>
				{content.titleSuffix}
			</h1>

			<p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-pretty text-white/70 sm:mt-6 sm:text-xl lg:mx-0">
				{content.description}
			</p>

			<div className="mt-6 flex flex-wrap justify-center gap-3 sm:mt-8 lg:justify-start">
				<a
					href={content.primaryHref}
					className="inline-flex items-center justify-center rounded-2xl bg-[#FF2E6E] px-6 py-3.5 text-sm font-semibold text-white shadow-[0_12px_34px_-8px_rgba(255,46,110,0.6)] transition hover:-translate-y-0.5 focus:ring-2 focus:ring-pink-400/50 focus:outline-none"
				>
					{content.primaryLabel}
				</a>

				<button
					type="button"
					onClick={() => globalThis.history.back()}
					className="inline-flex items-center justify-center rounded-2xl border border-white/15 bg-white/5 px-6 py-3.5 text-sm font-semibold text-white/90 backdrop-blur transition hover:cursor-pointer hover:bg-white/10 focus:ring-2 focus:ring-white/40 focus:outline-none"
				>
					{content.secondaryLabel}
				</button>
			</div>

			<p className="font-mono text-sm text-white/50 mt-5">{content.footerNote}</p>
		</section>
	);
}
